<template>
    <el-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="编辑"
        width="800px"
        append-to-body
        :before-close="handleClose">
        <div slot="title">
            <p>批量编辑
                <span class="sub-title ml10 text-color-gray font12px">（共{{dataList.length}}个{{typeText}}）</span>
            </p>
        </div>
        <div class="content-wrap">

            <div class="check-wrap">
                <p class="font12px text-bold mb6">请选择需要批量编辑的字段：</p>
                <el-checkbox-group v-model="checkedGroup" >
                    <el-checkbox v-for="item in formGroupList" :key="item.name" :label="item.name" :value="item.name" @change="resetFormField(item.name,$event)" class="check-item">{{item.label}}</el-checkbox>
                </el-checkbox-group>
                <el-divider></el-divider>
            </div>


            <el-form ref="form" :model="formItem"  @submit.native.prevent label-width="150px">
                <el-form-item
                    v-loading="formLoading"
                    v-for="item in formGroupList"
                    v-if="checkedGroup.includes(item.name)"
                    :label="item.label+'：'"
                    :prop="item.name"
                    :rules="{required: item.name!='note',type:item.source=='user'?'array':'string', message: item.label+'不能为空', trigger: 'change'}"
                    :key="item.name" class="mb8 label-required">
                    <template v-if="item.type=='content'">
                        <el-input
                            v-model="formItem[item.name]"
                            clearable
                            placeholder="请输入"
                            :maxlength="50"
                            :class="isClearNote?'line-through':''"
                            :disabled="isClearNote"
                            style="width: 300px;">
                        </el-input>
                        <span class="ml10 font12px text-color-gray">{{(formItem[item.name]||'').length}}/50</span>
                        <p class="mt6">
                            <el-checkbox v-model="isClearNote">清除备注</el-checkbox>
                            <span class="ml20 font12px text-color-gray">若选中了清除备注，则清空选中{{typeText}}的备注信息</span>
                        </p>
                    </template>
                    <el-radio-group v-else-if="item.type=='select'&&item.source=='user_system'" v-model="formItem[item.name]">
                        <el-radio v-for="inner in item.options" :key="inner.id" :label="inner.id">{{inner.name}}</el-radio>
                    </el-radio-group>
                    <ESelect
                        v-else-if="item.type=='select'&&item.source=='user'"
                        v-model="formItem[item.name]"
                        multiple
                        filterable
                        :multiple-limit="+item.max_allow_num||0"
                        placeholder="请选择"
                        style="width: 300px;">
                        <el-option
                            v-for="inner in item.options"
                            :key="inner.id"
                            :label="inner.name"
                            :value="inner.id">
                            {{inner.name}}
                        </el-option>
                    </ESelect>
                    <p v-if="item.type=='select'&&item.source=='user_system'" class="text-color-gray font12px">若需要恢复系统自动设置，请选择【去除人工设置】</p>

                </el-form-item>
            </el-form>

        </div>
        <div slot="footer" class="dialog-footer tac">
            <el-button type="default" @click="handleClose" class="action-btn mr20" v-matomo="{behaviorCategory: '标签管理('+apiTypeName+')',name: '批量编辑(取消)' }">取消</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="submitLoading" class="action-btn ml20" v-matomo="{behaviorCategory: '标签管理('+apiTypeName+')',name: '批量编辑(提交)' }">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import API from '@/api/baseInfo/tag.js';
    import matomoFun from "@/utils/matomo.js";
    export default {
        name: "BatchEditModal",
        props:{
            dataList:Array,
            tabType:String,
            formList:Array,
            apiTypeName:String,
        },
        components:{
        },
        data(){
            return {
                dialogVisible:false,
                submitLoading:false,
                formOptionsLoading:{},
                formGroupList:[],
                formItem:{

                },
                rules:{

                },
                checkedGroup:[],
                isClearNote:false,
            }
        },
        computed:{
            typeText(){
                let typeMap = {
                    bloc:'集团',
                    company:'客户',
                    platusername:'代理',
                    account:'账户',
                    plan:'计划',
                    subproject:'产品',
                    project:'项目',
                };
                return typeMap[this.tabType]||'';
            },
            formLoading(){
                return Object.values(this.formOptionsLoading).some(item=>item===true);
            },
        },
        methods:{
            showModal(){
                this.dialogVisible = true;
                this.$nextTick(()=>{
                    console.log('form-list',this.formList);
                    let formList = this.formList||[];
                    let selectList = formList.filter(item=>item.source=='user_system');
                    let selectMulList = formList.filter(item=>item.source=='user');
                    let content = formList.filter(item=>item.type=='content');
                    this.formGroupList = ([].concat(selectList,selectMulList,content)).map(item=>{
                        item.options = [];
                        return item;
                    });


                    content.forEach(item=>{
                        this.$set(this.formItem,item.name,'');
                    });
                    [].concat(selectList,selectMulList).forEach(item=>{
                        if(item.source=='user'){
                            this.$set(this.formItem,item.name,[]);
                        }else{
                            this.$set(this.formItem,item.name,'');
                        }
                        this.$set(this.formOptionsLoading,item.name,true);
                        API.getSearchList({
                            apiType:this.tabType,
                            search_type:item.name,
                            search_for:'edit',
                        }).then(res=>{
                            let resData = res.data||{};
                            this.$set(item,'options',resData.list||[]);
                            this.$set(item,'max_allow_num',resData.max_allow_num);
                            this.$set(this.formOptionsLoading,item.name,false);
                        },err=>{
                            console.log('getSearchList err',err);
                            this.$set(this.formOptionsLoading,item.name,false);
                        });
                    })
                })
            },
            handleClose() {
                matomoFun.trackEvent('标签管理('+this.apiTypeName+')', '点击', '批量编辑(取消)');
                this.dialogVisible = false;
                this.resetForm();
            },
            hideModal(){
                this.handleClose();
                this.$emit('close');
            },
            resetForm(){
                console.log('resetForm');
                this.checkedGroup = [];
                this.formOptionsLoading = {};
                this.formGroupList = [];
                this.isClearNote = false;
                this.$refs.form.resetFields();
            },
            resetFormField(item,val){
                if(val){
                    this.$refs['form'].clearValidate([item]);
                }
            },
            handleSubmit(){
                console.log('handleSubmit');
                this.$refs.form.validate((valid) => {
                    if (valid) {

                        if(this.checkedGroup.length<=0) return this.$message.error('请选择需要批量编辑的字段');

                        if(this.checkedGroup.includes('note')&&!this.formItem.note&&!this.isClearNote){
                            return this.$message.error('请设置备注');
                        }

                        let dataList = this.dataList||[];
                        let reqData = {};
                        reqData.apiType = this.tabType;
                        if(this.tabType=='subproject'){
                            reqData.plat_id_subitem_id = dataList.map(item=>item.plat_id+'#*||*#'+item.subitem_id);
                        }else if(this.tabType=='plan'){
                            reqData.plat_id_plan_id = dataList.map(item=>item.plat_id+'_'+item.plan_id);
                        }else if(this.tabType=='account'){
                            reqData.plat_id_account_id = dataList.map(item=>item.plat_id+'_'+item.account_id);
                        }else if(this.tabType=='company'){
                            reqData.customer_id = dataList.map(item=>item.customer_id);
                        }else if(this.tabType=='bloc'){
                            reqData.bloc_id = dataList.map(item=>item.bloc_id);
                        }else if(this.tabType=='project'){
                            reqData.project_id = dataList.map(item=>item.project_id);
                        }else if(this.tabType=='platusername'){
                            reqData.plat_id_plat_username = dataList.map(item=>item.plat_id+'_'+item.plat_username);
                        }

                        for(let item in this.formItem){
                            if(this.checkedGroup.includes(item)){
                                if(item=='note'){
                                    reqData.note = this.isClearNote?'':this.formItem.note;
                                }else{
                                    reqData[item] = Array.isArray(this.formItem[item])?this.formItem[item].join(','):this.formItem[item];
                                }
                            }
                        }
                        this.submitLoading = true;
                        API.saveTag(reqData).then(res=>{
                            console.log('save tag',res);
                            this.submitLoading = false;
                            this.$message.success(res.info||'操作成功');
                            this.$emit('update');
                            this.hideModal();

                        },err=>{
                            console.log('save tag err',err);
                            this.submitLoading = false;
                            this.$message.error(err.info||'操作失败');
                        })

                    } else {
                        return false;
                    }
                });


            },

        },
    }
</script>

<style lang="scss" scoped>

    .content-wrap{
        max-height: 360px;
        overflow-y: auto;

        .check-wrap{
            padding: 0 50px;
            .check-item{
                width: 150px;
                margin: 4px;

            }
        }


        ::v-deep .line-through input{
            text-decoration: line-through;
        }


    }
</style>
